import { CloseOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Carousel } from 'antd';

import { CustomArrow } from '../../../shared/components/custom-arrows/custom-arrows';
import { useData } from '../../../shared/hooks/use-data';
import {
    StyledCarouselContainer,
    StyledDescriptionParagraph,
    StyledDescriptionParagraphContainer,
    StyledImage,
    StyledModal,
    StyledParagraph,
    StyledTitle,
} from './custom-modal.style';
import { baseImagesUrl } from '../../../app';

export const CustomModal = () => {
    const { setDetailsModalInfo, detailsModalInfo } = useData();

    const { name, address, owner, description, lat, lon } = detailsModalInfo || {};

    return (
        <StyledModal
            centered
            open={!!detailsModalInfo}
            onCancel={() => setDetailsModalInfo(null)}
            footer={null}
            width={"55%"}
            closeIcon={<CloseOutlined />}
        >
            <StyledTitle>{name}</StyledTitle>
            <StyledParagraph><b>Адрес:</b> {address}</StyledParagraph>
            <StyledParagraph><b>Владелец: </b> {owner}</StyledParagraph>
            <StyledParagraph><b>Координаты: </b> {lat}, {lon}</StyledParagraph>
            <StyledDescriptionParagraphContainer>{description?.split('\n').map((row, index) => (
                <StyledDescriptionParagraph key={index}>
                    {row}
                </StyledDescriptionParagraph>
            ))}
            </StyledDescriptionParagraphContainer>


            <StyledCarouselContainer
                className='clear-default-arrows-in-carousel'
                onClick={(e) => e.stopPropagation()}
            >
                <Carousel
                    arrows
                    autoplay
                    prevArrow={<CustomArrow icon={<LeftOutlined />} />}
                    nextArrow={<CustomArrow icon={<RightOutlined />} />}
                >
                    {detailsModalInfo?.images?.map((url, index) => (
                        <div key={index} style={{ width: '43.75rem', height: '25.625rem' }}>
                            <StyledImage
                                src={`${baseImagesUrl}/${url}`}
                                preview={false}
                                alt="image"
                            />
                        </div>
                    ))}
                </Carousel>
            </StyledCarouselContainer>
        </StyledModal>
    )
}